var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "mt-2" }, [
    _c("div", {
      staticClass: "professionalMultiDatesCalendar datepicker-here"
    }),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("package-discount", {
          staticClass: "mt-4 ml-2",
          attrs: {
            numDates: _vm.numPackageSelectedDates,
            packageType: _vm.packageType
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.selectedDates
      ? _c(
          "section",
          _vm._l(_vm.selectedDates, function(selectedDate, index) {
            return _c("div", { staticClass: "row mt-3" }, [
              _c(
                "div",
                { staticClass: "col-6 p-0 d-flex align-items-center" },
                [
                  _c("span", { staticClass: "ml-2" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-primary-link",
                        attrs: { href: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.removeDate(index, selectedDate)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fal fa-trash-alt mr-2" })]
                    ),
                    _vm._v(" "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm._f("shortDate")(selectedDate)))
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6 p-0" },
                [
                  _c("professional-time-selection", {
                    attrs: {
                      mapDatesTimes: _vm.mapDatesTimes,
                      selectedDate: selectedDate,
                      availableTimes: _vm.availableTimes[index]
                    },
                    on: { selectTime: _vm.updateSelectedTime }
                  })
                ],
                1
              )
            ])
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e90cc52", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e90cc52","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/ProfessionalMultiDatesCalendar.vue
// module id = 1266
// module chunks = 0